'use client';

import { redirect } from 'next/navigation';

export default function BusinessRedirect() {
  // Get the user's language from localStorage (default to 'ar')
  const language = localStorage.getItem('i18nextLng') || 'ar';

  // Redirect /business → language-specific business page
  redirect(`/${language}/business`);
}
